import React from 'react';
import { ArrowRight, Play, Music } from 'lucide-react';

const Hero: React.FC = () => {
  return (
    <section className="relative bg-gradient-to-br from-primary-900 via-primary-800 to-primary-700 overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 bg-black bg-opacity-20"></div>
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-r from-primary-900/90 via-primary-800/80 to-transparent"></div>
        <div className="absolute top-0 left-0 w-full h-full">
          <div className="absolute top-10 left-10 w-72 h-72 bg-white/5 rounded-full blur-3xl"></div>
          <div className="absolute bottom-10 right-10 w-96 h-96 bg-accent-500/10 rounded-full blur-3xl"></div>
        </div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32">
        <div className="lg:grid lg:grid-cols-12 lg:gap-8 items-center">
          <div className="sm:text-center md:max-w-2xl md:mx-auto lg:col-span-7 lg:text-left">
            <h1 className="text-4xl font-extrabold text-white sm:text-5xl lg:text-6xl">
              <span className="block">Your vinyl journey</span>
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-accent-400 to-accent-300">
                starts here
              </span>
            </h1>
            
            <p className="mt-6 text-xl text-primary-100 max-w-3xl">
              We help you discover and choose the best Hi-Fi products from across various vendors 
              to get your vinyl listening journey started. From beginner setups to audiophile rigs, 
              find your perfect sound.
            </p>
            
            <div className="mt-10 flex flex-col sm:flex-row gap-4 sm:justify-center lg:justify-start">
              <button className="btn btn-primary">
                <Play className="w-5 h-5 mr-2" />
                Explore Setups
              </button>
              
              <button className="bg-white/10 hover:bg-white/20 text-white font-semibold px-8 py-4 rounded-xl transition-all duration-200 backdrop-blur-sm border border-white/20 inline-flex items-center">
                Browse Products
                <ArrowRight className="w-5 h-5 ml-2" />
              </button>
            </div>
            
            <div className="mt-12 grid grid-cols-3 gap-8 text-center">
              <div>
                <div className="text-3xl font-bold text-white">500+</div>
                <div className="text-primary-200">Products</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-white">50+</div>
                <div className="text-primary-200">Vendors</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-white">24/7</div>
                <div className="text-primary-200">Price Tracking</div>
              </div>
            </div>
          </div>
          
          <div className="mt-16 sm:mt-24 lg:mt-0 lg:col-span-5">
            <div className="relative">
              {/* Placeholder for hero image */}
              <div className="relative bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
                <div className="aspect-square bg-gradient-to-br from-white/20 to-white/5 rounded-xl flex items-center justify-center">
                  <div className="text-white/60 text-center">
                    <Music className="w-24 h-24 mx-auto mb-4" />
                    <p className="text-lg font-medium">Featured Setup</p>
                  </div>
                </div>
                
                <div className="mt-6 text-center">
                  <h3 className="text-xl font-semibold text-white">Premium Audio Experience</h3>
                  <p className="text-primary-200 mt-2">Carefully curated components for every budget</p>
                </div>
              </div>
              
              {/* Floating elements */}
              <div className="absolute -top-4 -right-4 bg-accent-500 text-white px-4 py-2 rounded-full text-sm font-semibold shadow-lg">
                Best Price
              </div>
              <div className="absolute -bottom-4 -left-4 bg-primary-500 text-white px-4 py-2 rounded-full text-sm font-semibold shadow-lg">
                Expert Curated
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;